document.addEventListener('DOMContentLoaded', function () {

  
  var swiper = new Swiper('.cust-carousel-section .images_box', {
      loopFillGroupWithBlank: true,
      loop: true,
      autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
      breakpoints: {
      0: {
      autoplay: {
            delay: 6000,
            disableOnInteraction: false
        },
        slidesPerView: 1.4,
        spaceBetween: 14,
        pagination: {
          el: '.swiper-pagination-comment',
          clickable: true
        }
      },
      768:{
      autoplay: {
            delay: 6000,
            disableOnInteraction: false
        },
        slidesPerView: 3,
        spaceBetween: 24,
        slidesPerGroup: 3
      }
    }
    });

    const swiperEl = document.querySelector('.cust-carousel-section .images_box');
    const slides = swiperEl.querySelectorAll('.cust-carousel-section .swiper-slide');

    if (window.innerWidth < 768) {
        swiperEl.style.width = '240px'
        swiperEl.style.margin = '0'
        swiperEl.style.overflow = 'visible'
    }

    const body = document.querySelector('body')
    document.querySelectorAll('.swiper-slide img').forEach(img => {
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function () {
            var WHMLCCAPok = document.querySelector('.WHMLCCAPok')
            body.style.overflow = 'hidden'
            if(WHMLCCAPok){
              WHMLCCAPok.style.display = 'none'
            }

            const closeBtn = document.createElement('div');
            closeBtn.className = 'zoom-close-btn';
            closeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00072 5.58599L11.9507 0.635986L13.3647 2.04999L8.41472 6.99999L13.3647 11.95L11.9507 13.364L7.00072 8.41399L2.05072 13.364L0.636719 11.95L5.58672 6.99999L0.636719 2.04999L2.05072 0.635986L7.00072 5.58599Z" fill="currentColor"></path>
            </svg>`

            const zoomContainer = document.createElement('div');
            zoomContainer.style.position = 'fixed';
            zoomContainer.style.top = '0';
            zoomContainer.style.left = '0';
            zoomContainer.style.width = '100%';
            zoomContainer.style.height = '100%';
            zoomContainer.style.backgroundColor = '#fff';
            zoomContainer.style.display = 'flex';
            zoomContainer.style.justifyContent = 'center';
            zoomContainer.style.alignItems = 'center';
            zoomContainer.style.zIndex = '9999';
            zoomContainer.style.cursor = 'zoom-out';

            const zoomedImg = document.createElement('img');
            zoomedImg.src = this.src.replace(/\?.*$/, '');
            zoomedImg.style.width = '80%';
            zoomedImg.style.height = '80%';
            zoomedImg.style.objectFit = 'contain';

            closeBtn.addEventListener('click', function () {
                document.body.removeChild(zoomContainer);
                body.style.overflowY = 'auto'
              if(WHMLCCAPok){
                ArlMORiXBt.style.display = 'block'
              }
            });
            zoomContainer.appendChild(closeBtn);
            zoomContainer.appendChild(zoomedImg);
            document.body.appendChild(zoomContainer);

            zoomedImg.addEventListener('click', function (e) {
                e.stopPropagation();
            });
        });
    });
})
